import { render, staticRenderFns } from "./batchRemove.vue?vue&type=template&id=10c23110&scoped=true"
import script from "./batchRemove.vue?vue&type=script&lang=js"
export * from "./batchRemove.vue?vue&type=script&lang=js"
import style0 from "./batchRemove.vue?vue&type=style&index=0&id=10c23110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c23110",
  null
  
)

export default component.exports